export default __webpack_public_path__ + "1ddedc0629635560a2e7199f919bf083.png";